import axiosPublicClient from "../../../../axiosPublicClient"
import axiosClient from "../../../../axiosClient"

// Lazily fetch a short-lived presigned view URL for a media field's uploaded file. The private S3
// object can no longer be opened by a direct link. Mirrors the upload service's context split:
//   - case-details (authenticated HR/ADMIN) has a backgroundRequestId -> authenticated call;
//   - candidate mid-form has only the form token (requestKey) -> public call.
const service = async ({ backgroundRequestId, requestKey, documentKey }) => {
    let response

    if (backgroundRequestId) {
        response = await axiosClient.post(`/background-check-form-media-url`, {
            backgroundRequestId,
            documentKey,
        })
    }
    else {
        response = await axiosPublicClient.post(`/background-check-form-media-url`, {
            requestKey,
            documentKey,
        })
    }

    return response.data
}

export default service
